<script setup lang="ts">
import { Icon as IconifyIcon } from '@iconify/vue'

defineOptions({ name: 'UiIcon' })

const props = defineProps({
  name: { type: String, required: true },
  dynamic: { type: Boolean, default: true },
  alt: { type: String, default: '' },
})

const isFilePath = computed(() => {
  return props.name.startsWith('/')
})
</script>

<template>
  <img v-if="isFilePath" :src="name" :alt="alt" class="custom-icon" />
  <IconifyIcon v-else :icon="name" />
</template>

<style scoped></style>
